import { GenericService } from "@/models/shared";
import { getApiUrlPath } from "@/models/constant";

import { ICriteriaModel } from "./request";
import { ICriteriaEntity } from "./response";

export class CriteriaFactory extends GenericService<ICriteriaModel, ICriteriaEntity> {
  constructor() {
    super({
      prefix: getApiUrlPath("Criteria")
    });
  }
}